import snakecaseKeys from 'snakecase-keys';
import { InjectiveExchangeV1Beta1Tx } from '@injectivelabs/core-proto-ts';
import { MsgBase } from '../../MsgBase.js';
/**
 * @category Messages
 */
export default class MsgPrivilegedExecuteContract extends MsgBase {
    static fromJSON(params) {
        return new MsgPrivilegedExecuteContract(params);
    }
    toProto() {
        const { params } = this;
        const message = InjectiveExchangeV1Beta1Tx.MsgPrivilegedExecuteContract.create();
        message.sender = params.sender;
        message.funds = params.funds;
        message.contractAddress = params.contractAddress;
        message.data = params.data.toExecJSON();
        return InjectiveExchangeV1Beta1Tx.MsgPrivilegedExecuteContract.fromPartial(message);
    }
    toData() {
        const proto = this.toProto();
        return {
            '@type': '/injective.exchange.v1beta1.MsgPrivilegedExecuteContract',
            ...proto,
        };
    }
    toAmino() {
        const proto = this.toProto();
        const message = {
            ...snakecaseKeys(proto),
        };
        return {
            type: 'exchange/MsgPrivilegedExecuteContract',
            value: message,
        };
    }
    toWeb3Gw() {
        const amino = this.toAmino();
        const { value } = amino;
        return {
            '@type': '/injective.exchange.v1beta1.MsgPrivilegedExecuteContract',
            ...value,
        };
    }
    toDirectSign() {
        const proto = this.toProto();
        return {
            type: '/injective.exchange.v1beta1.MsgPrivilegedExecuteContract',
            message: proto,
        };
    }
    toBinary() {
        return InjectiveExchangeV1Beta1Tx.MsgPrivilegedExecuteContract.encode(this.toProto()).finish();
    }
}
